import C, { lower } from 'constants';
import viKeyboardTab from '../icons/viKeyboardTab';
import viLock from '../icons/viLock';
import viInfinity from '../icons/viInfinity';

/**
 * List of supported Order Types
 */
export const list = [
  {
    name: 'Direct',
    value: 'direct',
    description: `These house multiple ${lower(C.SEGMENTS)} that will provide
      a roll up of information for directly serving out of the ISM system.`,
    icon: viKeyboardTab,
  },
  {
    name: 'Direct (External)',
    value: 'direct-ext',
    description: '',
    icon: viKeyboardTab,
  },
  {
    name: 'Programmatic Guaranteed Deal',
    value: 'programmatic',
    description: 'A programmatic deal served from a DSP that has guaranteed inventory.',
    icon: viLock,
  },
  {
    name: 'Always-On (PMP)',
    value: 'always-on-pmp',
    description: `A programmatic deal served from a DSP that has non-guaranteed inventory;
      generating a deal id for invitation-only programmatic auction, or evergreen deal,
      without a specific spend commitment.`,
    icon: viInfinity,
  },
];

export default {
  list,
};
